import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  TextField,
  TextFieldExtensionSchema,
  validateTextField,
} from './TextField';

export const AWSWorkloadTextFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AWSWorkload_TextField',
    component: TextField,
    validation: validateTextField,
    schema: TextFieldExtensionSchema,
  }),
);
